import { styled, ToggleButton } from "@mui/material";

const StyledToggleButton = styled(ToggleButton)(({ theme }) => {
    return {
        textTransform:'capitalize',
        borderRadius: theme.shape.borderRadius,
        ...theme.typography.h6,
        fontWeight: theme.typography.fontWeightBold,
        padding: '7.1px 11px',
        '&.Mui-selected': {
            color: theme.palette.primary.dark
        },
        '& .icon': {
            fontSize: 14
        },
    };
  });

  export default StyledToggleButton;    